export const TRUMPET_COLORS = {
    lightColor: "#6B6D8C",
    darkColor: "#494B6C"
}
